document.addEventListener('DOMContentLoaded',()=>{
  const b=document.querySelector('.menu-btn');
  const n=document.querySelector('.mobile-nav');
  if(b&&n)b.addEventListener('click',()=>{const open=b.getAttribute('aria-expanded')==='true';b.setAttribute('aria-expanded',String(!open));n.hidden=open;});
  document.querySelectorAll('.products-toggle').forEach(button=>{
    const grid=button.previousElementSibling;
    if(!grid||!grid.querySelector('.product-card-extra')){button.hidden=true;return;}
    button.addEventListener('click',()=>{
      const expanded=grid.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded',String(expanded));
      button.textContent=expanded?'Afficher moins':'Voir les 12 coffrets';
    });
  });
});

document.addEventListener('DOMContentLoaded',()=>{
  document.querySelectorAll('.zayra-review-shell').forEach(shell=>{
    const track=shell.querySelector('.zayra-review-track');
    const prev=shell.querySelector('.zayra-review-prev');
    const next=shell.querySelector('.zayra-review-next');
    if(!track) return;
    const step=()=>{const card=track.querySelector('.zayra-review-card');return card?card.getBoundingClientRect().width+18:300;};
    prev?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
    next?.addEventListener('click',()=>track.scrollBy({left:step(),behavior:'smooth'}));
  });
});
